<script lang="ts" setup>
defineProps<{
  name: string
  label?: string
  description?: string
  placeholder?: string
  disabled?: boolean
}>()
</script>

<template>
  <UiFormField
    v-slot="{ componentField }"
    :name="name"
    keep-value
  >
    <UiFormItem>
      <UiFormLabel>{{ label }}</UiFormLabel>

      <UiFormControl>
        <UiSelect v-bind="{ ...componentField, ...$attrs, disabled }">
          <UiFormControl>
            <UiSelectTrigger>
              <UiSelectValue :placeholder="placeholder" />
            </UiSelectTrigger>
          </UiFormControl>
          <UiSelectContent>
            <slot />
          </UiSelectContent>
        </UiSelect>
      </UiFormControl>
      <UiFormDescription v-if="description || $slots.description">
        <slot name="description">
          {{ description }}
        </slot>
      </UiFormDescription>
      <UiFormMessage />
    </UiFormItem>
  </UiFormField>
</template>
